let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hW8ni")).then(() => parcelRequire('30fTM'));